import React, { useState, useCallback } from 'react'

import { Report } from 'powerbi-report-component'
import PropTypes from 'prop-types'


const ShoppingReportFragment = ({
  token
}) => {
  // eslint-disable-next-line no-unused-vars
  const [report, setReport] = useState(null)
  const [showReport, setShowReport] = useState(true)

  const handleReportLoad = useCallback(async (data) => {
    if (!showReport) {
      setShowReport(true)
    }

    setReport(data)
  }, [showReport])


  const handleReportRender = useCallback(
    data => setReport(data),
    [setReport]
  )
  return (
    <Report
      tokenType="Aad"
      accessToken={ token }
      embedUrl="https://app.powerbi.com/reportEmbed"
      embedId="f2398d5b-48c2-41ee-8ec0-d5c396caddbc"
      groupId="049c3fb9-864c-4001-bfc1-1df372818bad"
      pageName="ReportSection"
      reportMode="View"
      permissions="Read"
      onLoad={ handleReportLoad }
      onRender={ handleReportRender }
      style={ {
        width: '100%',
        height: '200%'
      } }
      extraSettings={ {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        hideErrors: false
      } }
    />
  )
}

ShoppingReportFragment.propTypes = {
  token: PropTypes.string.isRequired
}

ShoppingReportFragment.defaultProps = {
}

export default ShoppingReportFragment
